import React, { createContext, useEffect, useState } from 'react'
import i18n from '../../i18n'
import { usePersistState } from '../hooks/state'
import { setThemePalette } from '../utils/colors'

export const Context = createContext()

function GlobalContext({ children }) {
    const [theme, setTheme] = usePersistState('theme', 'light')
    // Single source of truth is i18next (localStorage["language"]); the old
    // usePersistState('lang') kept a second, never-reconciled store.
    const [lang, setLangState] = useState(i18n.language)
    const setLang = (lng) => i18n.changeLanguage(lng)
    const [viewMode, setViewMode] = usePersistState('docsViewMode', 'cards')

    useEffect(() => {
        const onChange = (lng) => setLangState(lng)
        i18n.on('languageChanged', onChange)
        return () => i18n.off('languageChanged', onChange)
    }, [])

    useEffect(() => {
        setThemePalette(theme)
    }, [theme])

    return (
        <Context.Provider
            value={{
                lang,
                setLang,
                theme,
                setTheme,
                viewMode,
                setViewMode,
            }}
        >
            {children}
        </Context.Provider>
    )
}

export default GlobalContext
